"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SmileyFaceOutlineSVG = void 0;
var _react = _interopRequireDefault(require("react"));
var _logging = require("../../../util/logging");
var _IconFaceHappyOutline = _interopRequireWildcard(require("./IconFaceHappyOutline"));
// eslint-disable-next-line zillow/import/no-named-default

var SmileyFaceOutlineSVG = _IconFaceHappyOutline.FaceHappyOutlineSVG;
exports.SmileyFaceOutlineSVG = SmileyFaceOutlineSVG;
var SmileyFaceOutline = function SmileyFaceOutline(props) {
  (0, _logging.logDeprecation)("`IconSmileyFaceOutline` has been deprecated, use `IconFaceHappyOutline`");
  return /*#__PURE__*/_react.default.createElement(_IconFaceHappyOutline.default, props);
};
SmileyFaceOutline.displayName = 'IconSmileyFaceOutline';
var _default = SmileyFaceOutline;
exports.default = _default;